import { Button } from '@talentmesh/ui/components/button';
import { Spinner } from '@talentmesh/ui/components/spinner';
import { cn } from '@talentmesh/ui/lib/utils';
import { Copy } from 'lucide-react';
import React from 'react';
import UIStrings from '@/Utils/UIStrings';

interface HiddenProfileDataProps extends React.HTMLAttributes<HTMLDivElement> {
    icon?: React.ReactNode;
    iconContainerClassName?: string;
    label: string;
    value?: string[];
    isLoading: boolean;
    onReveal?: () => void;
}

const HiddenProfileData = ({
    isLoading,
    label,
    icon,
    iconContainerClassName,
    onReveal,
    value,
    ...props
}: HiddenProfileDataProps) => {
    return (
        <div {...props} className={cn('flex flex-row flex-wrap items-start', props.className)}>
            <div className="flex flex-row gap-1.5">
                <div className={cn('mt-0.5 h-6 w-4 place-content-center', iconContainerClassName)}>{icon}</div>
                <div className="flex flex-row pt-1">
                    <p className="text-sm leading-normal">
                        <span className="font-bold whitespace-pre">{`${label}: `}</span>
                        {!isLoading && !value && (
                            <Button
                                variant="link"
                                className="text-primary h-fit cursor-pointer p-0 font-bold"
                                onClick={onReveal}
                            >
                                {UIStrings.Reveal}
                            </Button>
                        )}
                    </p>
                    {value && (
                        <div className="flex flex-col gap-1">
                            {value.map((text) => (
                                <div key={text} className="flex place-items-center gap-2">
                                    <p className="text-sm leading-normal">{text}</p>
                                    <Button
                                        size="icon"
                                        className="size-2"
                                        variant="ghost"
                                        onClick={() => navigator.clipboard.writeText(text)}
                                    >
                                        <Copy />
                                    </Button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                {isLoading && <Spinner className="text-primary ml-2 size-6" />}
            </div>
        </div>
    );
};

export default HiddenProfileData;
